import AddStudent from "../../Components/Modals/AddStudent";
import Table from "../../Components/Table";
import { deleteUserById, getAllStudentForCms, getAllUsers } from "../../Services/MasterService";

const Students = () => {
    const columns = [
        {
            label: "First Name",
            value: "fname"
        },
        {
            label: "Middle Name",
            value: "mname"
        },
        {
            label: "Last Name",
            value: "lname"
        },
        {
            label: "Email",
            value: "email"
        },
        {
            label: "Phone",
            value: "phone"
        },
        {
            label: "DOB",
            value: "dob"
        },
        {
            label: "Company",
            value: "company_name"
        },
        {
            label: "Status",
            value: "status_name",
        }
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddStudent data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllStudentForCms}
            columns={columns}
            title={"Students Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
        // deleteApi={deleteUserById}
        />
    );
}

export default Students;